import React, { useContext, useMemo } from "react";
import "./UsersCodeDocument.scss";
import { Classroom, Student } from "../../../interfaces/User";
import IndividualDocumentCard from "./IndividualDocumentCard/IndividualDocumentCard";
import ListDocument from "./ListDocument/ListDocument";
import classNames from "classnames";
import { codePrintingContext } from "../UsersCodePrintingContext";

export const MAX_STUDENTS_PER_COLUMN = 12;

type props = {
    collection: Classroom;
    className: string;
};

const UsersCodeDocument = ({ collection, className }: props) => {
    const [codePrinting] = useContext(codePrintingContext);
    const isSelection = codePrinting.selectedStudents.length > 0;
    const selectedStudents =
        codePrinting.selectedStudents.length > 0
            ? codePrinting.selectedStudents
            : codePrinting.students;

    const pages = useMemo<Student[][][]>(() => {
        let students: Student[] = [];
        if (isSelection)
            students = collection.students.filter(
                (student) =>
                    selectedStudents.includes(student.id) && student.code
            );
        else students = collection.students.filter((student) => student.code);
        const _tables: Student[][] = generateBatches(
            students,
            isSelection ? 4 : MAX_STUDENTS_PER_COLUMN
        );
        const pages: Student[][][] = generateBatches(_tables, 2);
        return pages;
    }, [collection.students, isSelection, selectedStudents]);

    return (
        <div
            className={classNames("users-code-document", className)}
            aria-hidden={true}
        >
            {isSelection && (
                <>
                    {pages.map((page, index) => (
                        <article
                            key={"page" + index}
                            className="users-code-document__page --individual-cards"
                        >
                            {page.flat().map((student) => (
                                <IndividualDocumentCard
                                    className="users-code-document__page__card"
                                    key={student.id}
                                    student={student}
                                    classroomCode={collection.code}
                                />
                            ))}
                        </article>
                    ))}
                </>
            )}
            {!isSelection &&
                pages.map((page, index) => {
                    return (
                        <article
                            className="users-code-document__page"
                            key={index}
                        >
                            <ListDocument
                                classroom={collection}
                                page={page}
                                pageIndex={index}
                            />
                        </article>
                    );
                })}
        </div>
    );
};

export default UsersCodeDocument;

const generateBatches = <T,>(array: T[], modulo: number): T[][] => {
    let arrayIndex = -1;
    const newArray: T[][] = [];
    array.forEach((item, index) => {
        if (index % modulo === 0) {
            arrayIndex += 1;
            newArray.push([item]);
        } else newArray[arrayIndex].push(item);
    });
    return newArray;
};
